import { storage } from './storage';

/**
 * 带 TTL 的缓存查询工具函数
 * 用于低频变更的数据（如配置、渠道信息等），减少重复请求
 *
 * @param key - 缓存键名
 * @param ttlMs - 过期时间（毫秒）
 * @param fetcher - 数据获取函数
 * @returns 缓存或新获取的数据
 */
export async function cachedQuery<T>(
  key: string,
  ttlMs: number,
  fetcher: () => Promise<T>
): Promise<T> {
  const cacheKey = `cachedQuery:${key}`;

  // 尝试从缓存获取（storage.get 会自动检查过期）
  const cached = storage.get(cacheKey);
  if (cached !== null && cached !== undefined) {
    console.log(`[cachedQuery] 命中缓存: ${key}`);
    return cached as T;
  }

  // 缓存未命中或已过期，执行请求
  console.log(`[cachedQuery] 缓存未命中，发起请求: ${key}`);
  const result = await fetcher();

  // 将毫秒转换为小时存入缓存（storage.set 的 expiryTime 单位是小时）
  const ttlHours = ttlMs / (60 * 60 * 1000);
  storage.set(cacheKey, result, ttlHours);

  return result;
}

/**
 * 清除指定的缓存
 * 用于用户登出、切换账号时清除缓存
 *
 * @param key - 缓存键名
 */
export function clearCachedQuery(key: string): void {
  const cacheKey = `cachedQuery:${key}`;
  storage.remove(cacheKey);
  console.log(`[cachedQuery] 已清除缓存: ${key}`);
}

/**
 * 清除所有 cachedQuery 缓存
 * 注意：这会遍历所有 storage，性能开销较大，谨慎使用
 */
export function clearAllCachedQueries(): void {
  // 清除已知的缓存 key
  const knownKeys = ['appConfig'];
  knownKeys.forEach((key) => {
    clearCachedQuery(key);
  });
}

